export default function formatDecimalNumber(value?: number, precision?: number): string {
  if (value == null) {
    return '-';
  }
  if (isNaN(value) || !isFinite(value)) {
    return new Intl.NumberFormat('en', {
      minimumFractionDigits: precision,
    }).format(0);
  }

  return new Intl.NumberFormat('en', {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  }).format(value);
}
